<script lang="ts">
	export let title: string;
	export let description: string;
	export let buttonText: string = 'Open tool';
	export let buttonTextMobile: string = 'Open';
</script>

<div
	class="flex items-center justify-between
	w-[340px] sm:w-[450px] p-5 bg-white rounded-lg border border-primary-200 bg-primary-25 shadow-md hover:brightness-[95%] cursor-pointer z-10 opacity-[99%]
	dark:bg-navy-900 dark:border-zinc-800 dark:hover:brightness-110"
>
	<div class="flex items-center">
		<slot name="icon" />
		<div class="flex flex-col items-start text-left">
			<h3 class="text-sm font-semibold dark:text-zinc-100">{title}</h3>
			<p class="text-gray-600 text-xs dark:text-zinc-400">{description}</p>
		</div>
	</div>
	<div class="w-2"></div>
	<div
		class="text-sm font-semibold text-gray-700 border border-gray-300 px-3 py-1 rounded whitespace-nowrap
		dark:text-zinc-300 dark:border-zinc-700"
	>
		<span class="hidden sm:block">{buttonText}</span>
		<span class="block sm:hidden">{buttonTextMobile}</span>
	</div>
</div>
